/**
 * Seasonal theme definitions for Vietnamese holidays/events.
 * Each theme overrides brand colors and adds floating decorations.
 */

export const SEASONAL_THEMES = {
  tet: {
    id: 'tet',
    name: { en: 'Tet Holiday', vi: 'T\u1EBFt Nguy\u00EAn \u0110\u00E1n' },
    icon: '\uD83C\uDFEE',
    description: { en: 'Lunar New Year', vi: 'N\u0103m m\u1EDBi' },
    monthRange: [1, 2],
    colors: {
      light: {
        brandPrimary: '#c41e3a',
        brandSecondary: '#d4a017',
        brandLight: '#fde8e8',
        brandShadow: 'rgba(196, 30, 58, 0.3)',
        brandShadowStrong: 'rgba(196, 30, 58, 0.4)',
        brandFocus: 'rgba(196, 30, 58, 0.15)',
      },
      dark: {
        brandPrimary: '#e84057',
        brandSecondary: '#f0c040',
        brandLight: '#3a1e1e',
        brandShadow: 'rgba(232, 64, 87, 0.25)',
        brandShadowStrong: 'rgba(232, 64, 87, 0.35)',
        brandFocus: 'rgba(232, 64, 87, 0.15)',
      },
    },
    particles: ['\uD83C\uDF38', '\uD83C\uDFEE', '\u2728', '\uD83E\uDDE7', '\uD83C\uDF3A'],
    particleCount: 15,
  },

  valentine: {
    id: 'valentine',
    name: { en: "Valentine's Day", vi: 'L\u1EC5 T\u00ECnh Nh\u00E2n' },
    icon: '\u2764\uFE0F',
    description: { en: 'Day of Love', vi: 'Ng\u00E0y T\u00ECnh Y\u00EAu' },
    monthRange: [2, 2],
    colors: {
      light: {
        brandPrimary: '#e0457b',
        brandSecondary: '#f06898',
        brandLight: '#fde8f0',
        brandShadow: 'rgba(224, 69, 123, 0.3)',
        brandShadowStrong: 'rgba(224, 69, 123, 0.4)',
        brandFocus: 'rgba(224, 69, 123, 0.15)',
      },
      dark: {
        brandPrimary: '#f06898',
        brandSecondary: '#f898b8',
        brandLight: '#3a1e28',
        brandShadow: 'rgba(240, 104, 152, 0.25)',
        brandShadowStrong: 'rgba(240, 104, 152, 0.35)',
        brandFocus: 'rgba(240, 104, 152, 0.15)',
      },
    },
    particles: ['\u2764\uFE0F', '\uD83D\uDC95', '\uD83C\uDF39', '\u2728', '\uD83E\uDE77'],
    particleCount: 12,
  },

  reunification: {
    id: 'reunification',
    name: { en: 'Reunification Day', vi: 'Ng\u00E0y Gi\u1EA3i Ph\u00F3ng' },
    icon: '\u2B50',
    description: { en: 'April 30th', vi: '30 th\u00E1ng 4' },
    monthRange: [4, 4],
    colors: {
      light: {
        brandPrimary: '#cc0000',
        brandSecondary: '#e6b800',
        brandLight: '#fde8e0',
        brandShadow: 'rgba(204, 0, 0, 0.3)',
        brandShadowStrong: 'rgba(204, 0, 0, 0.4)',
        brandFocus: 'rgba(204, 0, 0, 0.15)',
      },
      dark: {
        brandPrimary: '#e84040',
        brandSecondary: '#f0d060',
        brandLight: '#3a1e1e',
        brandShadow: 'rgba(232, 64, 64, 0.25)',
        brandShadowStrong: 'rgba(232, 64, 64, 0.35)',
        brandFocus: 'rgba(232, 64, 64, 0.15)',
      },
    },
    particles: ['\u2B50', '\uD83C\uDDFB\uD83C\uDDF3', '\uD83C\uDF86', '\u2728'],
    particleCount: 10,
  },

  children: {
    id: 'children',
    name: { en: "Children's Day", vi: 'Qu\u1ED1c t\u1EBF Thi\u1EBFu nhi' },
    icon: '\uD83C\uDF88',
    description: { en: 'June 1st', vi: '1 th\u00E1ng 6' },
    monthRange: [6, 6],
    colors: {
      light: {
        brandPrimary: '#e06030',
        brandSecondary: '#40a0e0',
        brandLight: '#fef0e8',
        brandShadow: 'rgba(224, 96, 48, 0.3)',
        brandShadowStrong: 'rgba(224, 96, 48, 0.4)',
        brandFocus: 'rgba(224, 96, 48, 0.15)',
      },
      dark: {
        brandPrimary: '#f08050',
        brandSecondary: '#60b8f0',
        brandLight: '#2e2418',
        brandShadow: 'rgba(240, 128, 80, 0.25)',
        brandShadowStrong: 'rgba(240, 128, 80, 0.35)',
        brandFocus: 'rgba(240, 128, 80, 0.15)',
      },
    },
    particles: ['\uD83C\uDF88', '\uD83C\uDF1F', '\uD83C\uDF80', '\uD83C\uDF89', '\uD83E\uDDE8'],
    particleCount: 14,
  },

  midAutumn: {
    id: 'midAutumn',
    name: { en: 'Mid-Autumn Festival', vi: 'T\u1EBFt Trung Thu' },
    icon: '\uD83C\uDF15',
    description: { en: 'Moon Festival', vi: 'T\u1EBFt Trung Thu' },
    monthRange: [8, 9],
    colors: {
      light: {
        brandPrimary: '#d4880a',
        brandSecondary: '#8b5e3c',
        brandLight: '#fef5e0',
        brandShadow: 'rgba(212, 136, 10, 0.3)',
        brandShadowStrong: 'rgba(212, 136, 10, 0.4)',
        brandFocus: 'rgba(212, 136, 10, 0.15)',
      },
      dark: {
        brandPrimary: '#f0b030',
        brandSecondary: '#c08860',
        brandLight: '#2e2818',
        brandShadow: 'rgba(240, 176, 48, 0.25)',
        brandShadowStrong: 'rgba(240, 176, 48, 0.35)',
        brandFocus: 'rgba(240, 176, 48, 0.15)',
      },
    },
    particles: ['\uD83C\uDF15', '\uD83C\uDFEE', '\u2B50', '\uD83E\uDD6E', '\uD83C\uDF1F'],
    particleCount: 12,
  },

  nationalDay: {
    id: 'nationalDay',
    name: { en: 'National Day', vi: 'Qu\u1ED1c Kh\u00E1nh' },
    icon: '\uD83C\uDDFB\uD83C\uDDF3',
    description: { en: 'September 2nd', vi: '2 th\u00E1ng 9' },
    monthRange: [9, 9],
    colors: {
      light: {
        brandPrimary: '#cc0000',
        brandSecondary: '#e6b800',
        brandLight: '#fde8e0',
        brandShadow: 'rgba(204, 0, 0, 0.3)',
        brandShadowStrong: 'rgba(204, 0, 0, 0.4)',
        brandFocus: 'rgba(204, 0, 0, 0.15)',
      },
      dark: {
        brandPrimary: '#e84040',
        brandSecondary: '#f0d060',
        brandLight: '#3a1e1e',
        brandShadow: 'rgba(232, 64, 64, 0.25)',
        brandShadowStrong: 'rgba(232, 64, 64, 0.35)',
        brandFocus: 'rgba(232, 64, 64, 0.15)',
      },
    },
    particles: ['\uD83C\uDDFB\uD83C\uDDF3', '\u2B50', '\uD83C\uDF86', '\uD83C\uDF87'],
    particleCount: 10,
  },

  christmas: {
    id: 'christmas',
    name: { en: 'Christmas', vi: 'Gi\u00E1ng Sinh' },
    icon: '\uD83C\uDF84',
    description: { en: 'Merry Christmas', vi: 'Ch\u00FAc M\u1EEBng Gi\u00E1ng Sinh' },
    monthRange: [12, 12],
    colors: {
      light: {
        brandPrimary: '#1a7a3a',
        brandSecondary: '#c41e3a',
        brandLight: '#e8f5e8',
        brandShadow: 'rgba(26, 122, 58, 0.3)',
        brandShadowStrong: 'rgba(26, 122, 58, 0.4)',
        brandFocus: 'rgba(26, 122, 58, 0.15)',
      },
      dark: {
        brandPrimary: '#40a860',
        brandSecondary: '#e84057',
        brandLight: '#1e2e20',
        brandShadow: 'rgba(64, 168, 96, 0.25)',
        brandShadowStrong: 'rgba(64, 168, 96, 0.35)',
        brandFocus: 'rgba(64, 168, 96, 0.15)',
      },
    },
    particles: ['\u2744\uFE0F', '\uD83C\uDF84', '\u2B50', '\uD83C\uDF81', '\u2728'],
    particleCount: 16,
  },

  spring: {
    id: 'spring',
    name: { en: 'Spring', vi: 'M\u00F9a Xu\u00E2n' },
    icon: '\uD83C\uDF38',
    description: { en: 'Season of Blossoms', vi: 'M\u00F9a hoa n\u1EDF' },
    monthRange: [2, 4],
    colors: {
      light: {
        brandPrimary: '#d4567a',
        brandSecondary: '#7ab648',
        brandLight: '#fde8f0',
        brandShadow: 'rgba(212, 86, 122, 0.3)',
        brandShadowStrong: 'rgba(212, 86, 122, 0.4)',
        brandFocus: 'rgba(212, 86, 122, 0.15)',
      },
      dark: {
        brandPrimary: '#e87898',
        brandSecondary: '#90d060',
        brandLight: '#3a1e28',
        brandShadow: 'rgba(232, 120, 152, 0.25)',
        brandShadowStrong: 'rgba(232, 120, 152, 0.35)',
        brandFocus: 'rgba(232, 120, 152, 0.15)',
      },
    },
    particles: ['\uD83C\uDF38', '\uD83C\uDF3C', '\uD83C\uDF3A', '\uD83E\uDD8B', '\uD83C\uDF3F'],
    particleCount: 14,
  },

  summer: {
    id: 'summer',
    name: { en: 'Summer', vi: 'M\u00F9a H\u00E8' },
    icon: '\u2600\uFE0F',
    description: { en: 'Sunny Days', vi: 'Ng\u00E0y n\u1EAFng' },
    monthRange: [5, 7],
    colors: {
      light: {
        brandPrimary: '#e08820',
        brandSecondary: '#0098b8',
        brandLight: '#fef5e0',
        brandShadow: 'rgba(224, 136, 32, 0.3)',
        brandShadowStrong: 'rgba(224, 136, 32, 0.4)',
        brandFocus: 'rgba(224, 136, 32, 0.15)',
      },
      dark: {
        brandPrimary: '#f0a840',
        brandSecondary: '#30b8d8',
        brandLight: '#2e2818',
        brandShadow: 'rgba(240, 168, 64, 0.25)',
        brandShadowStrong: 'rgba(240, 168, 64, 0.35)',
        brandFocus: 'rgba(240, 168, 64, 0.15)',
      },
    },
    particles: ['\u2600\uFE0F', '\uD83C\uDF34', '\uD83C\uDF0A', '\uD83E\uDD69', '\uD83C\uDF3B'],
    particleCount: 12,
  },

  autumn: {
    id: 'autumn',
    name: { en: 'Autumn', vi: 'M\u00F9a Thu' },
    icon: '\uD83C\uDF42',
    description: { en: 'Falling Leaves', vi: 'L\u00E1 r\u01A1i' },
    monthRange: [9, 11],
    colors: {
      light: {
        brandPrimary: '#c06020',
        brandSecondary: '#a04830',
        brandLight: '#fef0e4',
        brandShadow: 'rgba(192, 96, 32, 0.3)',
        brandShadowStrong: 'rgba(192, 96, 32, 0.4)',
        brandFocus: 'rgba(192, 96, 32, 0.15)',
      },
      dark: {
        brandPrimary: '#e08040',
        brandSecondary: '#c06848',
        brandLight: '#2e2018',
        brandShadow: 'rgba(224, 128, 64, 0.25)',
        brandShadowStrong: 'rgba(224, 128, 64, 0.35)',
        brandFocus: 'rgba(224, 128, 64, 0.15)',
      },
    },
    particles: ['\uD83C\uDF42', '\uD83C\uDF41', '\uD83C\uDF43', '\uD83C\uDF44', '\uD83C\uDF30'],
    particleCount: 14,
  },

  winter: {
    id: 'winter',
    name: { en: 'Winter', vi: 'M\u00F9a \u0110\u00F4ng' },
    icon: '\u2744\uFE0F',
    description: { en: 'Cool & Cozy', vi: 'L\u1EA1nh v\u00E0 \u1EA5m c\u00FAng' },
    monthRange: [11, 1],
    colors: {
      light: {
        brandPrimary: '#4088b8',
        brandSecondary: '#6878a8',
        brandLight: '#e8f0f8',
        brandShadow: 'rgba(64, 136, 184, 0.3)',
        brandShadowStrong: 'rgba(64, 136, 184, 0.4)',
        brandFocus: 'rgba(64, 136, 184, 0.15)',
      },
      dark: {
        brandPrimary: '#60a8d8',
        brandSecondary: '#8898c0',
        brandLight: '#1e2830',
        brandShadow: 'rgba(96, 168, 216, 0.25)',
        brandShadowStrong: 'rgba(96, 168, 216, 0.35)',
        brandFocus: 'rgba(96, 168, 216, 0.15)',
      },
    },
    particles: ['\u2744\uFE0F', '\u2744\uFE0F', '\uD83C\uDF28\uFE0F', '\u2728', '\uD83E\uDDE3'],
    particleCount: 16,
  },
};

// Sort themes chronologically by start month
export const SEASONAL_THEME_LIST = Object.values(SEASONAL_THEMES).sort(
  (a, b) => a.monthRange[0] - b.monthRange[0]
);

/**
 * Returns theme IDs that are suggested for the given month (1-12).
 */
export const getSuggestedThemeIds = (month) => {
  return SEASONAL_THEME_LIST
    .filter(theme => {
      const [start, end] = theme.monthRange;
      if (start <= end) {
        return month >= start && month <= end;
      }
      // Wraps around year (e.g. winter: 11-1)
      return month >= start || month <= end;
    })
    .map(t => t.id);
};
